module.exports = __webpack_public_path__ + "static/img/msg-bull.d8669e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/msg-bull.png
// module id = kjn4
// module chunks = 1